var poll_default = {
  "fontElementMap": "Dc0dz",
  "container": "pfkG6",
  "fullscreen": "h1TUg",
  "background_overlay": "pkafF",
  "with_image": "XEWHc",
  "options": "_48QYu",
  "webview": "z25D9",
  "grid": "lfk6F",
  "option": "kJWRM",
  "cta_button": "f5Q2L",
  "add_option": "ZbkTx",
  "see_more": "Csqi-",
  "list": "mIZTv",
  "column": "_3Qie2",
  "additional_note": "rvp2T",
  "spinner": "_9InWA",
  "spin": "oE2Ga",
  "shown": "_3MPPc",
  "error": "RRWJs"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
